<template>
  <div class="page">
    <div class="page-header">
      <el-carousel height="70vh" direction="vertical" :autoplay="true" style="z-index: 0">
        <el-carousel-item v-for="item in imgs" :key="item">
          <img :src="$urlFile+item.bannerImg" alt="" height="100%" width="100%" style="z-index: 0">
        </el-carousel-item>
      </el-carousel>
      <div class="page-header-left animate__animated animate__fadeInLeft animate__delay-1s">
        <div class="logo-box">
          <img class="logo" src="../../assets/home/name_logos.png" alt="">
        </div>
        <div class="title-list" :style="tabIndex==index?'font-weight: bold;color: #3a8ee6':''"
             v-for="(item,index) in titleList" :key="index" @click="changeIndex(index)" @mouseover="hoverIndex = index"
             @mouseleave="hoverIndex = null">
          <span class="title-list-left animate__animated animate__slideInLeft" v-if="hoverIndex === index"> > </span>
          <span style="margin: 0 10px">{{ item }}</span>
          <span class="title-list-right animate__animated animate__slideInRight" v-if="hoverIndex === index"> < </span>
        </div>
      </div>
      <!--      <div class="subdivtitle animate__animated animate__zoomInUp animate__delay-1s"></div>-->

    </div>
    <div ref="targetElement"></div>
    <!-- <div style="width: 100%;margin: 0 auto;padding-left: 18%;padding-right: 18%;" v-if="tabIndex===0">
      <div style="width: 40%;height: 3px;background-image: radial-gradient(circle at center, #0f7eff 0%, transparent 100%);margin: auto;margin-bottom: 0.6em;margin-top: 2em"></div>

      <div style="margin-bottom: 0.6em;color: #3a8ee6;font-size: 2.5em;letter-spacing: 0.5em">{{ $t('home.summary') }}</div>
      <div style="width: 40%;height: 3px;background-image: radial-gradient(circle at center, #0f7eff 0%, transparent 100%);margin: auto;margin-bottom: 0.6em"></div>

      <div style="margin-top: 1.2em;color: #1b1b1c;font-weight: bold;font-size: 1.4em;text-align: left;text-indent: 2.7em;">
        澜沧江-湄公河综合执法安全合作中心是澜湄流域第一个综合性的执法安全合作类政府间国际组织。</div>
      <el-row>
        <div class="text">
          根据《关于建立澜沧江-湄公河综合执法安全合作中心谅解备忘录》，澜湄执法中心将根据各成员国的执法需求制定行动纲领。
          在尊重各成员国主权和法律的基础上，逐步将中心打造成为一个统筹协调本地区预防、打击跨国违法犯罪，情报信息融合交流，专项治理联合行动，加强执法能力建设的综合平台。
          致力于为各成员国执法部门提供优质、高效的服务，共同应对地区安全形势的变化和风险挑战，为澜湄国家各领域合作、发展提供安全保障。
        </div>
       <el-col :span="8" class="text">
          根据《关于建立澜沧江-湄公河综合执法安全合作中心谅解备忘录》，澜湄执法中心将根据各成员国的执法需求制定行动纲领。
        </el-col>
        <el-col :span="8" class="text">
          在尊重各成员国主权和法律的基础上，逐步将中心打造成为一个统筹协调本地区预防、打击跨国违法犯罪，情报信息融合交流，专项治理联合行动，加强执法能力建设的综合平台。
        </el-col>
        <el-col :span="8" class="text">
          致力于为各成员国执法部门提供优质、高效的服务，共同应对地区安全形势的变化和风险挑战，为澜湄国家各领域合作、发展提供安全保障。
        </el-col>
      </el-row>

    </div> -->
    <div class="summary" style="" v-if="tabIndex===0">
      <div class="title">
        <span style="font-family: fzxbsjt"><i class="el-icon-menu" style="margin-right: 10px"></i>{{
            $t('home.summary')
          }}</span>
        <div class="line"></div>
        <div>

          <div class="text" v-if="this.$i18n.locale == 'zh'">
            <span style="font-weight: bolder;font-size: 1em;">
              澜沧江-湄公河综合执法安全合作中心是澜湄流域第一个综合性的执法安全合作类政府间国际组织。<br>
            </span>
          </div>
          <div class="text" v-if="this.$i18n.locale == 'zh'">

            根据《关于建立澜沧江-湄公河综合执法安全合作中心谅解备忘录》，澜湄执法中心将根据各成员国的执法需求制定行动纲领。
            在尊重各成员国主权和法律的基础上，逐步将中心打造成为一个统筹协调本地区预防、打击跨国违法犯罪，情报信息融合交流，专项治理联合行动，加强执法能力建设的综合平台。
            致力于为各成员国执法部门提供优质、高效的服务，共同应对地区安全形势的变化和风险挑战，为澜湄国家各领域合作、发展提供安全保障。

          </div>

          <div class="text" v-if="this.$i18n.locale == 'en'">
            Our official name in Chinese is “澜沧江-湄公河综合执法安全合作中心”. And the official name in English is “The Lancang-Mekong Integrated Law Enforcement and Security Cooperation Center”, abbreviated as “LMLECC”. “LM” is the abbreviation of “Lancang-Mekong River”, “LECC” is the abbreviation of “Law Enforcement and Security Cooperation Center”. “LM” stands for “Lancang-Mekong River” and “LECC” stands for “Law Enforcement and Security Cooperation Center”.

          </div>

        </div>
      </div>
    </div>
    <name-and-logo v-if="tabIndex===2"></name-and-logo>
    <organizational-structure v-if="tabIndex===1"></organizational-structure>
    <!--    <leadership v-if="tabIndex===3"></leadership>-->

  </div>
</template>
<script>
import NameAndLogo from "./nameAndLogo.vue";
import Leadership from "./leadership.vue";
import OrganizationalStructure from "./organizationalStructure.vue";
import {getBannerList} from "../../api/banner";

export default {
  components: {OrganizationalStructure, Leadership, NameAndLogo},
  data() {
    return {
      tabIndex: 0,
      hoverIndex: null, // 用于存储当前鼠标悬浮的title-list的索引
      imgs:[],
      titleList: [this.$t('home.summary'), this.$t('home.organizationalStructure'), this.$t('home.nameAndLogo')]/*,this.$t('home.leadership')*/
    };
  },
  created() {
    if (this.$route.query.index != undefined) {
      this.tabIndex = this.$route.query.index
    }
  },
  mounted() {
    if (this.$route.query.index != undefined) {
      this.tabIndex = this.$route.query.index
    }
    getBannerList({index: 1, size: 10}).then((res) => {
      this.imgs = res.data

    })
  },
  methods: {
    changeIndex(index) {
      this.tabIndex = index
      this.$nextTick(() => {
        this.$refs.targetElement.scrollIntoView({behavior: 'smooth'});
      });
    }
  }
};
</script>
<style lang="less" scoped>
@media only screen and (min-width: 800px) {
  .page {
    width: 100%;
    height: 100%;
    position: relative;

    .page-header {
      width: 100%;
      height: 70vh;
      /*background-image: url(../../assets/img/aboutbg001.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;*/
      position: relative;


      .page-header-left {
        position: absolute;
        top: 15%;
        left: 8%;
        background-color: rgba(255, 254, 254, 0.8);
        width: 23%;
        height: 65%;
        border-bottom: #0e1113 solid 10px;
        padding: 20px;
        border-radius: 5px;

        .logo-box {
          margin-top: 10px;
          margin-bottom: 20px;

          .logo {
            width: 28%;
          }
        }

        .title-list {
          display: flex;
          justify-content: center;
          width: 100%;
          text-align: center;
          font-size: 3vh;
          //font-weight: bold;
          line-height: 6vh;
          cursor: pointer;
          font-family: "方正小标宋_GBK";
        }

        .title-list:hover {
          color: #09598f;
        }

        .title-list-left, .title-list-right {
          //display: none; /* 默认情况下不显示箭头 */
          font-size: 2.5vh;
          font-weight: bold;
        }
      }

      .subdivtitle {
        position: absolute;
        background-image: url(../../assets/home/home_title_blue.png);
        width: 50%;
        height: 20%;
        right: 6%;
        top: 39%;
        background-repeat: no-repeat;
        background-position: center; /* 可根据需求调整对齐方式 */
        background-size: 100% 100%;
      }
    }

    .text {
      text-indent: 2.4em;
      text-align: justify;
      font-size: 0.8em;
      line-height: 2em;
      font-family: 微软雅黑;
      font-weight: 600;
    }

    .line {
      width: 100%;
      height: .6vh;
      margin: 0 auto;
      background: linear-gradient(to right,
      #678dda, /* 开始颜色 */ #6e6aec 50%, /* 在中心点附近使用过渡色 */ #678dda /* 结束颜色 */);
      margin-top: 1vh;
      margin-bottom: 1vh;
    }

    .title {
      text-align: left;
      line-height: 1.5em;
      font-size: 2.5vh;
      font-weight: bold;
      margin-top: 60px;
    }

    .summary {
      width: 100%;
      margin: 0 auto;
      padding-left: 18%;
      padding-right: 18%;
    }
  }
}

@media only screen and (max-width: 800px) {
  .page {
    width: 100%;
    height: 100%;
    position: relative;

    .page-header {
      width: 100%;
      height: 70vh;
      /*background-image: url(../../assets/img/aboutbg001.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 100%;*/
      position: relative;


      .page-header-left {
        position: absolute;
        top: 15%;
        left: 10%;
        background-color: rgba(255, 254, 254, 0.8);
        width: 80%;
        height: 70%;
        border-bottom: #0e1113 solid 10px;
        padding: 20px;
        border-radius: 5px;

        .logo-box {
          margin-top: 10px;
          margin-bottom: 20px;

          .logo {
            width: 28%;
          }
        }

        .title-list {
          display: flex;
          justify-content: center;
          width: 100%;
          text-align: center;
          font-size: 3vh;
          //font-weight: bold;
          line-height: 6vh;
          cursor: pointer;
          font-family: "方正小标宋_GBK";
        }

        .title-list:hover {
          color: #09598f;
        }

        .title-list-left, .title-list-right {
          //display: none; /* 默认情况下不显示箭头 */
          font-size: 2.5vh;
          font-weight: bold;
        }
      }

      .subdivtitle {
        position: absolute;
        background-image: url(../../assets/home/home_title_blue.png);
        width: 50%;
        height: 20%;
        right: 6%;
        top: 39%;
        background-repeat: no-repeat;
        background-position: center; /* 可根据需求调整对齐方式 */
        background-size: 100% 100%;
      }
    }

    .text {
      text-indent: 2.4em;
      text-align: justify;
      font-size: 0.8em;
      line-height: 2em;
      font-family: 微软雅黑;
      font-weight: 600;
    }

    .line {
      width: 100%;
      height: .6vh;
      margin: 0 auto;
      background: linear-gradient(to right,
      #678dda, /* 开始颜色 */ #6e6aec 50%, /* 在中心点附近使用过渡色 */ #678dda /* 结束颜色 */);
      margin-top: 1vh;
      margin-bottom: 1vh;
    }

    .title {
      text-align: left;
      line-height: 1.5em;
      font-size: 2.5vh;
      font-weight: bold;
      margin-top: 60px;
    }
    .summary {
      width: 100%;
      margin: 0 auto;
      padding-left: 5%;
      padding-right: 5%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/summary.vue